import { NahradniHodinovaSazba } from '../nahradniHodinovaSazba';
import { NahradniSazbaLakovaci } from '../nahradniSazbaLakovaci';
import { SmluvniCenaND } from '../smluvniCenaND';

export const DEPENDENT_TABLES = <const>[
	NahradniHodinovaSazba.name,
	SmluvniCenaND.name,
	NahradniSazbaLakovaci.name,
];

export const editActions = {
	PREVZETI_HODNOT: 'prevzetiHodnot',
};

export type DependentTableNames = typeof DEPENDENT_TABLES[number];
